














































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
import ThDropdownVue from "../components/ThDropdown.vue";
import ChargeDetailVue from "../components/Charge/ChargeDetail.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";


import { mapGetters } from "vuex";
import version from "@/version";
@Component({
	...mapGetters(["accountBook"]),
	components: {
		"th-dropdown": ThDropdownVue,
		"charge-detail": ChargeDetailVue,
        "user-tree": AllUserTreeVue,
	},
})
export default class DebitNote extends Vue {
	accounterNo: string = this.$store.state.account.no;
    accounterName: string = "所属人姓名";
	// 打开tree
	isTree: boolean = false;
	openTree() {
		this.isTree = !this.isTree;
	}
	// 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
	tmp: UserTree | null = null;
	treeExpand(data: UserTree) {
		this.tmp = data;
	}
	// 点击tree中的名字(node)
	isScope: boolean = false;
	handleNodeClick(data: Account) {
		this.isScope = true;
		if (data.name) this.accounterName = data.name;
		this.currentPage = 1;
		this.$store.dispatch("clearSearchKey");
		this.accounterNo = data.no;
		this.fetchData();
		this.isTree = false;
	}
	// 关闭tree
	closeTree() {
		this.isTree = false;
	}
	dataList: Charge.DebitNote[] = [];
	rangeVal: Date = new Date(); //时间值
	payList: DataTable.DropItem[] = [
		{
			text: "全部",
			id: 0,
		},
		{
			text: "银行--对公",
			id: 1,
		},
		{
			text: "银行--对人",
			id: 2,
		},
		{
			text: "现金",
			id: 3,
		},
		{
			text: "支付宝",
			id: 4,
		},
		{
			text: "微信",
			id: 5,
		},
	];
	feeList: DataTable.DropItem[] = [
		{
			text: "所有",
			id: 0,
		},
		{
			text: "记账费",
			id: 1,
		},
		{
			text: "账本费",
			id: 2,
		},
	];
	payStatus: DataTable.DropItem = this.payList[0];
	feeStatus: DataTable.DropItem = this.feeList[0];
	chargeType: string | null = null;
	paymentMethod: string | null = null;
	// pickerOptions初值为空对象,因为还未获取到限制的时间
	disabledDate: DatePickerOptions = {};
	currentPage: number = 1;
	pageSize: number = 15;
	totalElements: number = 0;

	total: {
		actualCharge: number;
		totalCharge: number;
	} | null = null;

	mounted() {
		this.fetchData();
	}
	    // 修改页数SIze
	changeSize(size: number) {
    	this.pageSize = size;
		this.fetchData();
    }

	// 获取表格数据
	fetchData() {
		if (this.payStatus.id != 0) {
			this.paymentMethod = this.payStatus.text;
		} else {
			this.paymentMethod = null;
		}
		if (this.feeStatus.id != 0) {
			this.chargeType = this.feeStatus.text;
		} else {
			this.chargeType = null;
		}
		Vue.axios
			.post(
				`charge/statement?page=${this.currentPage - 1}&size=${this.pageSize
				}`,
				{
					accounterNo: this.accounterNo,
					chargeType: this.chargeType,
					paymentMethod: this.paymentMethod,
					chargeDate: this.$utils.simpleDateFormat(
						new Date(this.rangeVal),
						"m",
						true
					),
					query: this.$store.state.searchKey,
				}
			)
			.then((res) => {
				this.dataList = res.data.statements.content;
				this.totalElements = res.data.statements.totalElements;
				this.total = res.data.total;
			});
	}
	// 分页
	handleCurrentChange(val: number) {
		this.currentPage = val;
		this.fetchData();
	}
	// 详情
	tableData: Charge.ChargeRecord | null = null;
	showDetail: boolean = false;
	chargeDetail(data: Charge.ChargeRecord) {
		this.tableData = data;
		this.showDetail = true;
	}
	closeDetail() {
		this.showDetail = false;
	}
	detailSuccess() {
		this.showDetail = false;
	}

	changeDate() {
		this.currentPage = 1;
		this.fetchData();
	}

	async exportCharge() {
		const date = this.$utils.simpleDateFormat(
			new Date(this.rangeVal),
			"m",
			true
		);
		// await Vue.axios.get(`export/charge/statement?accounterNo=${this.$store.state.account.no}&chargeType=${this.chargeType}&paymentMethod=${this.paymentMethod}&chargeDate=${date}&query=${this.$store.state.searchKey}&version=${version}&token=${this.$store.state.account.token}`);
		this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/charge/statement?accounterNo=${this.$store.state.account.no}&chargeType=${this.chargeType === null ? "" : this.chargeType}&paymentMethod=${this.paymentMethod === null ? "" : this.paymentMethod}&chargeDate=${date}&query=${this.$store.state.searchKey}&version=${version}&token=${this.$store.state.account.token}`);
	}
}
